import React from 'react'

import Chart from './ProjectionChart.d3'
import ChartWrapper from '../ChartWrapper'

const ProjectionChart = ({ data, inModal, estimateChartFrequency }) => {
  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, inModal, estimateChartFrequency }}
      updateProps={{ data, estimateChartFrequency }}
      margin={{ BOTTOM: 50, LEFT: 50, TOP: 20 }}
    />
  )
}

export default ProjectionChart
